import { GenericApi } from '~/api/generic-api';
import { FormModel } from '~/models/form-model';
import { FetchUtils, HttpMethod } from '~/utils/fetch-utils';

export class BenefitsPaymentsCentreApi {
	/**
	 * Process batch
	 * @param recordId record ID
	 */
	public static async processBenefitPayment(
		recordId: string | number,
	): Promise<void> {
		return FetchUtils.fetchJSON(
			HttpMethod.PUT,
			'api/benefits-payments/:recordId/process',
			{ recordId },
		);
	}

	/**
	 * This is a read-only operation that is only used by the UI to validate the provided form model so we can fetch an
	 * empty Benefits Payments Dispersal model. This is linked it to the Exit batch parent record as the child record
	 * with the highest priority. This API should only be used to get a new Dispersal if one does not already exist.
	 */
	public static async getEmptyDispersal(
		formModel: FormModel,
		totalMethod: string,
		preservedMethod: string,
	): Promise<FormModel> {
		return FetchUtils.fetchJSON(
			HttpMethod.PATCH,
			'api/benefits-payments/empty-dispersal',
			{
				'function-name': 'benefits-payments',
				'field-model': true,
				totalMethod,
				preservedMethod,
			},
			GenericApi.translateFormModelToClassicFormStateModel(formModel),
		).then(GenericApi.translateFormModelFormat);
	}

	/**
	 * This is a read-only operation that is only used by the UI to validate the provided form model so we can fetch an
	 * empty Benefits Payments Payment Details model. This is linked it to the Exit batch parent record as the child record
	 * with the highest priority. This API should only be used to get a new Dispersal if one does not already exist.
	 */
	public static async getEmptyPaymentDetail(
		formModel: FormModel,
	): Promise<FormModel> {
		return FetchUtils.fetchJSON(
			HttpMethod.PATCH,
			'api/benefits-payments/empty-payment-detail',
			{
				'function-name': 'benefits-payments',
				'field-model': true,
			},
			GenericApi.translateFormModelToClassicFormStateModel(formModel),
		).then(GenericApi.translateFormModelFormat);
	}

	/**
	 * This operation updates Benefit Parameters ONLY. Will return Original values of
	 * dispersal list
	 */
	public static async saveBenefitParameters(
		recordId: string | number,
		formModel: FormModel,
	): Promise<FormModel> {
		return FetchUtils.fetchJSON(
			HttpMethod.PUT,
			'api/benefits-payments/:recordId/saveBenefitParameters',
			{ recordId },
		).then(GenericApi.translateFormModelFormat);
	}

	/**
	 * This updates Dispersal Defaults ONLY of existing BS record based on passed values. Will return Original values of
	 * benefits parameters
	 */
	public static async saveDispersalDefaults(
		recordId: string | number,
		formModel: FormModel,
	): Promise<FormModel> {
		return FetchUtils.fetchJSON(
			HttpMethod.PUT,
			'api/benefits-payments/:recordId/saveDispersalDefaults',
			{ recordId },
		).then(GenericApi.translateFormModelFormat);
	}
}
